<template>
  <!-- 导航开始 -->
  <div class='commonClientinfoContact' :class="{scrollHide: isShowStoreBox}" ref="scrollBox">
    <div class="mainBox" v-for="(app,index) in data" :key="index">
      <div class="card">
        <div class="body w_user">
          <span class="rounded-circle">
            {{app.name.charAt(0)}}
          </span>
          <div class="wid-u-info">
            <h6>
              {{app.name}} · {{app.sex==='1'?'男':'女'}} · {{app.relation}}
              <span @click="storeBoxFun(true,2,app.id)" class="btn btn-secondary btn-sm animated animated4 fadeIn">改</span>
            </h6>
            <p class="text-muted m-b-0">
              电话：{{app.phone?app.phone:'—'}}
            </p>
            <p class="text-muted m-b-0">
              微信：{{app.wechat?app.wechat:'—'}}
            </p>
            <p class="text-muted m-b-0">
              邮箱：{{app.email?app.email:'—'}}
            </p>
          </div>
          <hr>
          <div class="row clearfix description">
            <div class="col-12">
              {{app.content?app.content:'暂无备注...'}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!is_empty">
      <div v-if='isLoading && !isSearchLoading' class='dynamicMessage'>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </div>
      <div v-if='isNodata' class='dynamicMessage'>
        — 没有更多了 —
      </div>
      <div v-if='isError' class='dynamicMessage'>
        — 请求失败 —
      </div>
    </div>
    <div class="emptyBox" v-if="is_empty && data.length===0">
      <i class="iconfont icon-kong"></i>
    </div>
    <div v-if="isShowStoreBox" class="traceStoreBoxModel">
      <div class="traceStoreBox">
        <div class="mb-3">
          <span class="content">红色：客户联系方式中；</span>
          <span class="content">黄色：黑名单中；</span>
          <span class="content">蓝色：附属成员中</span>
          <p class="content">注：此结果为完全匹配，如abc匹配abc，ab则无法匹配abc</p>
          <div class="row">
            <div class="col-4">
              电话：<i :class="{'text-success':phoneBool===1,'text-danger':phoneBool===2,'text-warning':phoneBool===3,'text-primary':phoneBool===4}" class="iconfont icon-luyin"></i>
            </div>
            <div class="col-4">
              微信：<i :class="{'text-success':wechatBool===1,'text-danger':wechatBool===2,'text-warning':wechatBool===3,'text-primary':wechatBool===4}" class="iconfont icon-luyin"></i>
            </div>
          </div>
        </div>
        <div class="xuanzeBox mb-3">
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">姓名</span>
              </div>
              <input type="text" class="form-control" v-model="name">
            </div>
          </div>
          <div class="box">
            <multiselect v-model="sexVal" track-by="name" label="name" placeholder="性别" :options="sexArr" :searchable="false"  :show-labels="false">
              <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </multiselect>
          </div>
          <div class="last">
            <multiselect v-model="relationVal" track-by="name" label="name" placeholder="关系" :options="relationArr" :searchable="false"  :show-labels="false">
              <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
            </multiselect>
          </div>
        </div>
        <div class="xuanzeBox mb-3">
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  电话
                </span>
              </div>
              <input type="text" class="form-control" v-model="phone">
            </div>
          </div>
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  微信
                </span>
              </div>
              <input type="text" class="form-control" v-model="wechat">
            </div>
          </div>
          <div class="last">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">
                  邮箱
                </span>
              </div>
              <input type="text" class="form-control" v-model="email">
            </div>
          </div>
        </div>
        <div class="textareaBox mb-3">
          <textarea class="form-control" aria-label="With textarea" v-model="contentVal"></textarea>
        </div>
        <div class="anniuBox">
          <button type="button" @click.self="storeBoxFun(false)" class="btn btn-secondary btn-round">取消</button>
          <button type="button" v-if="btnTitle==='修改'" @click="submitDelFun()" class="btn btn-danger btn-round">
            <i v-if="isDelLoading" class='iconfont icon-jiazai xuanzhuan'></i> 删除
          </button>
          <button type="button" @click="submitFun()" class="btn btn-success btn-round">
            <i v-if="isSubmitLoading" class='iconfont icon-jiazai xuanzhuan'></i> {{btnTitle}}
          </button>
        </div>
      </div>
    </div>
    <span v-if="!isShowStoreBox" @click="storeBoxFun(true,1)" class="tianjia btn btn-success btn-round">添加</span>
    <div class="searchLoadingBox" v-if="isSearchLoading">
      <span>
        <i class='iconfont icon-jiazai xuanzhuan'></i>
      </span>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import commons from '../../../util/commons';

export default {
  name: 'commonClientinfoContact',
  props: ['token'],
  data() {
    return {
      isShowStoreBox: false,
      isSubmitLoading: false,
      isDelLoading: false,
      btnTitle: '',
      phoneBool: 1,
      wechatBool: 1,
      landlineBool: 1,
      info: {},

      str: '',
      // 手机号
      phone: '',
      // 微信
      wechat: '',
      // 邮箱
      email: '',
      // 姓名
      name: '',
      // 关系
      relationVal: null,
      // 性别
      sexVal: null,
      // 备注
      contentVal: '',
      // 关系
      relationArr: [
        { name: '父母', id: '1' },
        { name: '配偶', id: '2' },
        { name: '子女', id: '3' },
        { name: '朋友', id: '4' },
        { name: '本人', id: '5' },
      ],
      // 性别
      sexArr: [
        { name: '男', id: '1' },
        { name: '女', id: '0' },
      ],

      // 分页
      data: [], // 数据队列
      allPage: 0, // 总页数
      allNumber: 0, // 总页数
      page: 1, // 当前页数
      is_empty: false, // 是否为空数据(没有任何数据)
      isNodata: false, // 没有更多了
      isLoading: false, // 是否请求中
      isError: false, // 请求失败
      // 加载中
      isSearchLoading: true,

    };
  },
  watch: {
    phone: {
      handler(newVal) {
        if (this.info) {
          if (this.info.phone === newVal) {
            this.phoneBool = 1;
          } else {
            // 获取是否重复
            resultCommons.apiCrmcontactrepeat(this, { keys: newVal }).then((app) => {
              // 如果是本身的则直接显示绿色
              this.phoneBool = app.data.bool;
            });
          }
        } else {
          // 获取是否重复
          resultCommons.apiCrmcontactrepeat(this, { keys: newVal }).then((app) => {
            // 如果是本身的则直接显示绿色
            this.phoneBool = app.data.bool;
          });
        }
      },
      deep: true,
    },
    wechat: {
      handler(newVal) {
        if (this.info) {
          if (this.info.wechat === newVal) {
            this.wechatBool = 1;
          } else {
            // 获取是否重复
            resultCommons.apiCrmcontactrepeat(this, { keys: newVal }).then((app) => {
              this.wechatBool = app.data.bool;
            });
          }
        } else {
          // 获取是否重复
          resultCommons.apiCrmcontactrepeat(this, { keys: newVal }).then((app) => {
            this.wechatBool = app.data.bool;
          });
        }
      },
      deep: true,
    },
  },
  computed: {
    whereJson() {
      return {
        token: this.token,
      };
    },
    submitData() {
      return {
        token: this.token,
        name: this.name,
        sex: commons.whereArrStr(this.sexVal),
        relation: this.relationVal ? this.relationVal.name : '',
        phone: this.phone,
        email: this.email,
        wechat: this.wechat,
        content: this.contentVal,
        str: this.str,
      };
    },
  },
  methods: {
    storeBoxFun(bool, type, str = '') {
      // 如果显示模态框
      if (bool) {
        // 添加
        if (type === 1) {
          this.info = null;
          this.name = '';
          this.sexVal = null;
          this.relationVal = null;
          this.phone = '';
          this.email = '';
          this.wechat = '';
          this.contentVal = '';
          this.str = '';
          this.btnTitle = '添加';
        }
        // 修改
        if (type === 2) {
          const info = this.data.find(app => app.id === str);
          this.info = info;
          this.name = info.name;
          this.sexVal = { id: info.sex, name: info.sex === '1' ? '男' : '女' };
          this.relationVal = { name: info.relation };
          this.phone = info.phone;
          this.email = info.email;
          this.wechat = info.wechat;
          this.contentVal = info.content;
          this.str = str;
          this.btnTitle = '修改';
        }
      } else {
        this.info = null;
        this.str = '';
        this.btnTitle = '';
      }
      this.isShowStoreBox = bool;
    },
    // 状态切换
    loadingFun(bool) {
      if (bool === 1) {
        // 加载中
        this.isNodata = false;
        this.isError = false;
        this.isLoading = true;
      } else if (bool === 2) {
        // 关闭所有
        this.isNodata = false;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else if (bool === 3) {
        // 没有更多了
        this.isNodata = true;
        this.isError = false;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      } else {
        // 请求失败了
        this.isNodata = false;
        this.isError = true;
        this.isLoading = false;
        this.isSearchLoading = false; // 悬浮加载中
      }
    },
    // 初始化个人的
    initData(reload = false) {
      if (reload) {
        this.data = [];
        this.allPage = 0;
        this.page = 1;
        this.allNumber = 0;
        this.is_empty = false; // 是否为空数据(没有任何数据)
        this.isNodata = false; // 没有更多了
        this.isLoading = false; // 是否请求中
        this.isError = false; // 请求失败
        this.isSearchLoading = true; // 悬浮加载中
      }
      return resultCommons.apiCrmContact(this, { page: this.page, token: this.token }, reload).then((ob) => {});
    },
    scroll(that, node) {
      node.onscroll = () => {
        // 距离底部200px时加载一次
        const bottomOfWindow = node.scrollHeight - node.scrollTop - node.clientHeight <= 150;
        console.log(bottomOfWindow);
        // 距离200像素时 & 可以请求时 & 页码小于等于最大页码时 & !没有更多时 & !空数据时
        if (bottomOfWindow && that.isLoading === false && !that.isNodata && !that.isError && !that.is_empty) {
          this.initData();
        }
      };
    },
    submitFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交中
      this.isSubmitLoading = true;
      resultCommons.apiCrmContactStore(this, this.submitData).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 提交中
        this.isSubmitLoading = false;
        if (ob.state === 200) {
          const info = ob.data.info;
          if (ob.data.type === 'join') {
            // 加入
            this.data.unshift(info);
          } else {
            // 更新
            this.data.forEach((app, index) => {
              if (app.id === info.id) {
                this.data[index] = info;
              }
            });
          }
          // 隐藏box
          this.isShowStoreBox = false;
          // 提示
          this.$message.showMsgBox({
            type: 'success',
            content: ob.message,
          });
        } else {
          // 提示
          this.$message.showMsgBox({
            type: 'warning',
            content: ob.message,
          });
        }
      });
    },
    submitDelFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 提交中
      this.isDelLoading = true;

      // 执行删除
      resultCommons.apiCrmContactDel(this, { str: this.str }).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 提交中
        this.isDelLoading = false;
        if (ob.state === 200) {
          // 隐藏box
          this.isShowStoreBox = false;
          this.data = this.data.filter(app => app.id !== this.str);
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
    Multiselect,
  },
  created() {
    // 初始化
    this.initData().then((app) => {
      this.isSearchLoading = false;
    });
  },
  mounted() {
    // 创建事件
    this.scroll(this, this.$refs.scrollBox);
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonClientinfoContact{
  flex: 1;
  overflow-y: auto;
  background: #F6F6F6;
  padding: 15px;
  div.emptyBox{
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    i{
      font-size: 70px;
      color: rgba(0,0,0,0.1);
    }
  }
  span.tianjia{
    position: absolute;
    display: inline-block;
    width: 90px;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    margin-bottom: 20px;
    text-align: center;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
  }
  div.traceStoreBoxModel{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.1);
    backdrop-filter: blur(5px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    div.traceStoreBox{
      justify-content: center;
      align-items: center;
      box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);
      padding: 15px 15px;
      background: #FFFFFF;
      div.xuanzeBox{
        display: flex;
        flex-direction: row;
        div.box{
          margin-right: 6px;
          flex: 1;
        }
        div.last{
          flex: 1;
          display: flex;
          align-items: center;
          margin: 0;
          div.form-group{
            margin: 0;
            .form-check{
              margin: 0;
            }
          }
        }
      }
      div.textareaBox{
        textarea{
          height: 90px;
          border-radius: 5px;
        }
      }
      div.anniuBox{
        text-align: right;
      }
    }
  }
  div.mainBox{
    margin-bottom: 10px;
    div.card{
      background: #FFFFFF;
      border-radius: 15px;
      margin: 0;
      border: 1px solid #EEEEEE;
      .body{
        padding: 20px;
        h6{
          padding-bottom: 10px;
          span{
            float: right;
            font-family: 'gilroy-extrabold';
            padding: 2px 5px;
            display: none;
            border-radius: 6px;
          }
        }
        hr{
          margin: 10px 0;
        }
        .rounded-circle{
          display: inline-block;
          float: left;
          width: 60px;
          height: 60px;
          background: #E5E5E5;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 28px;
        }
      }
    }
    &:hover{
      div.card{
        .body{
          h6{
            span{
              font-family: 'gilroy-regular';
              display: block;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/clientinfo/contact.vue